// extracted by mini-css-extract-plugin
module.exports = {"link":"AuthorByLine_link__3C7r8","list":"AuthorByLine_list__NNQ80","listItem":"AuthorByLine_listItem__V0N4W"};